import type { ImportBatch } from "../types";
import type { ImportAdapter } from "./ImportAdapter";
import { BlingAdapter } from "./BlingAdapter";
import { GenericAdapter } from "./GenericAdapter";
import { UpsellerAdapter } from "./UpsellerAdapter";

export type { ColumnMapping, ParsedFile } from "./ImportAdapter";

export function resolveImportAdapter(source: ImportBatch["source"]): ImportAdapter {
  if (source === "bling") return new BlingAdapter();
  if (source === "upseller") return new UpsellerAdapter();
  return new GenericAdapter();
}
